import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumbs, useUser } from './hooks';
import { Icon, Toast } from 'react-frontier';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { bindClick, bindClose, bindToggle } from './SiteUtil';
import { CDN_URL } from './API';
import { Notifications } from './components';
import { SidebarItem } from './screens';
import classNames from 'classnames';
import UserAccess from './UserAccess';

import './style/site.scss';

interface SiteContainerProps{
	outlet: JSX.Element,
}

var SiteContainer = (props: SiteContainerProps)=>{
	var { t } = useTranslation();
	var { user, logout, hasAccess } = useUser();
	var { breadcrumbs, sidebar } = useBreadcrumbs();
	
	var [drawer, setDrawer] = useState<boolean>(false);
	var [showNotifications, setShowNotifications] = useState<boolean>(false)
	var location = useLocation();

	useEffect(()=>{
		setDrawer(false)
	}, [location.pathname]);

	var SidebarContents = useMemo(() => {
		var hideMenu = location.pathname.match(/^\/events\/\d+/);
		return <>
			<div className="site">	
				<img src={`${CDN_URL}/logo/LogoBH_Large.webp`} />
			</div>
			<SidebarItem text='Notificaciones' iconName='bell' badge={user?.notifications > 0 ? user.notifications : null} onClick={bindClick(setShowNotifications, !showNotifications)}/>
			{sidebar}
			{!hideMenu && <>
				<div className="divider">Cuenta</div>
				<SidebarItem text='Mis Notificaciones' iconName='bell' to='/user/notifications' />
				<SidebarItem text='Mis Gastos' iconName='money-bill' to='/user/expenses' />
				{hasAccess(UserAccess.INVENTORY.CREATE_INVENTORY_REQUESTS) && <SidebarItem text='Mis Solicitudes' iconName='laptop-file' to='/user/requests' />}
				<SidebarItem text='Mis Cuentas' iconName='credit-card' to='/accounts' />
			</>}
			<div className="filler"></div>
			<SidebarItem text='Cerrar sesión' iconName='sign-out' extra onClick={logout} />
		</>
	}, [location, user, sidebar]);

	if(!user) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<img src={`${CDN_URL}/logo/LogoBL_Small.webp`} alt="AREMA" style={{ borderRadius: 4, width: 100, height: 100, objectFit: 'contain' }} />
	</div>

	return <Toast.Provider>
		<div className="ar site">
			<div className="site-container">
				<div className="sidebar">
					{SidebarContents}
				</div>
				<Notifications open={showNotifications} onClose={bindClick(setShowNotifications, false)} />
				<div className="contents">
					<div className="navbar">
						{breadcrumbs && breadcrumbs.length>1 ? (
							<Link className='nav' to={breadcrumbs[breadcrumbs.length-2].url}>
								<Icon name='arrow-left' className='disabled' />
							</Link>
						) : (
							<div className="nav disabled">
								<Icon name='arrow-left' className='disabled' />
							</div>
						)}
						<div className="items">
							{!breadcrumbs || breadcrumbs.length==0 ? (
								<div className="item active">
									<Icon name='ticket' />
									AREMA
								</div>
							) : (
								breadcrumbs.map((a, i, arr)=>(
									<React.Fragment key={`brdcrb-${a.url}`}>
										<Link to={a.url} className={classNames("item", {
											active: i>=(arr.length-1)
										})}>
											{!!a.iconName && <Icon name={a.iconName} />}
											{a.text}
										</Link>
										{!!(i<arr.length-1) && (
											<div className='divider'>/</div>
										)}
									</React.Fragment>
								))
							)}
						</div>
						<div className="drawer" onClick={bindToggle(drawer, setDrawer)}>
							<Icon name='bars' />
						</div>
					</div>
					<div className="contents" id="siteContents">
						{props.outlet}
					</div>
					<TransitionGroup component={React.Fragment}>
						{!!showNotifications && (
							<CSSTransition enter addEndListener={null} timeout={{ appear: 0, exit: 500 }}>
								<div className="dimmer" onClick={bindClick(setShowNotifications, false)}></div>
							</CSSTransition>
						)}
					</TransitionGroup>
				</div>
				<TransitionGroup component={React.Fragment}>
					{!!drawer && (
						<CSSTransition enter addEndListener={null} timeout={{ appear: 0, exit: 500 }}>
							<div className="overlay" onClick={bindClose(setDrawer, false)}></div>
						</CSSTransition>
					)}
				</TransitionGroup>
				<TransitionGroup component={React.Fragment}>
					{!!drawer && (
						<CSSTransition enter addEndListener={null} timeout={{ appear: 0, exit: 500 }}>
							<div className="ar drawer">
								{SidebarContents}
							</div>
						</CSSTransition>
					)}
				</TransitionGroup>
			</div>
		</div>
	</Toast.Provider>
}

export default SiteContainer;
